module.exports = __webpack_public_path__ + "media/images/iconmonstr-smiley-2-240-fd4cf2e8f89d387daa7a9678bb022d74.png";